import { FunctionComponent } from "react"
import { Button, Col, Row, Table } from "react-bootstrap"
import Container from "react-bootstrap/Container"
import { useNavigate } from "react-router-dom"
import FilterField from "../components/FilterField"
import { Role } from "../data/models.interface"
import { useGetRolesQuery } from "../hooks/queries/useGetRolesQuery"
import useSessionStorage from "../hooks/useSessionStorage"
import useSort from "../hooks/useSort"
import { filterProperty } from "../utils/StringUtils"

interface IRolesPage {}
const RolesPage: FunctionComponent<IRolesPage> = () => {
	const navigate = useNavigate()
	const rolesQuery = useGetRolesQuery()
	const roles = rolesQuery.data?.roles
	// loading layout
	if (!roles) return <LoadingLayout />
	// normal layout
	return (
		<Container>
			<h2 className="text-center mt-4">Roles</h2>
			<RolesTable roles={roles} />
			<Row>
				<Col xs="auto">
					<BackButton />
				</Col>
				<Col />
				<Col xs="auto">
					<Button variant="success" onClick={() => navigate("/roles/new")}>
						New
					</Button>
				</Col>
			</Row>
		</Container>
	)
}
export default RolesPage

const LoadingLayout = () => {
	return (
		<Container style={{ maxWidth: 500 }}>
			<h2 className="text-center mt-4">Roles</h2>
			<div className="text-center">Loading</div>
		</Container>
	)
}

interface IRolesTable {
	roles: Role[]
}
const RolesTable = ({ roles }: IRolesTable) => {
	const navigate = useNavigate()
	const [nameFilter, setNameFilter] = useSessionStorage("roles-name", "")
	const { sortBy, sort } = useSort<Role>("name")
	roles = filterProperty(roles, (r) => r.name!, nameFilter)
	roles = sort(roles)
	return (
		<Table striped bordered hover size="sm">
			<thead>
				<tr>
					<th onClick={() => sortBy("name")}>Name</th>
					<th>Passes</th>
				</tr>
				<tr>
					<td>
						<FilterField filter={nameFilter} setFilter={setNameFilter} placeholder="Filter Name" />
					</td>
				</tr>
			</thead>
			<tbody>
				{roles?.map((role) => (
					<tr key={role.id} onClick={() => navigate(`/roles/${role.id}`)}>
						<td>{role.name}</td>
						<td>{role.passes.length}</td>
					</tr>
				))}
			</tbody>
		</Table>
	)
}

const BackButton = () => {
	const navigate = useNavigate()
	return (
		<Button variant="secondary" className="mb-3" onClick={() => navigate(-1)}>
			Back
		</Button>
	)
}
